import css from "standard/css";

const style = css`
  .search {
    position: relative;
    display: flex;
    gap: var(--spacing_inset-xs);
  }

  .search__input {
    appearance: none;
    background-color: transparent;
    border: var(--border-width-hairline) solid var(--color-master);
    border-radius: var(--border-radius-sm);
    color: var(--color-master-dark);
    font-family: var(--font-family-base);
    font-size: var(--font-size-xs);
    flex-grow: 1;
    font-weight: var(--font-weight-regular);
    height: 52px;
    line-height: var(--line-height-default);
    padding: 0 var(--spacing_inset-xs) 0 var(--spacing-sm);
    width: 100%;
  }

  .search__img {
    position: absolute;
    left: 10px;
    top: 14px;
  }

  .search__button {
    align-items: center;
    background-color: #3481b2;
    border: none;
    border-bottom: 2px solid #5c9ac1;
    border-radius: var(--border-radius-sm);
    box-shadow: 0 10px 0 #2a668c;
    text-shadow: 0 2px 0 rgba(0, 0, 0, 0.2);
    color: var(--color-pure-white);
    cursor: pointer;
    display: flex;
    font-family: var(--font-family-highlight);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-bold);
    padding: var(--spacing_inset-nano) var(--spacing_inset-xs);
    height: 42px;
    justify-content: center;
    width: 150px;
  }

  .search__button:active {
    box-shadow: none; 
    transform: translateY(5px);
  }
`;

export default style;
